export default __webpack_public_path__ + "static/media/logo-blue.d9fbd62c.svg";